
<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :page.sync="params.page"
      :items-per-page="limit"
      @page-count="pageCount"
      hide-default-footer
      :items="reportCourseList"
      class="pa-5 ma-md-5 font-weight-light"
      elevation="3"
    >
      <template v-slot:top>
        <v-toolbar flat color="white table-header pa-0">
          <div class="mr-md-5 xs-full-width">
            <v-text-field
              outlined
              rounded
              v-model="searchdata"
              append-icon="search"
              @click:append="searchInfoCourse"
              placeholder="Search"
              clearable
            ></v-text-field>
          </div>
          <div class="ml-5 xs-full-width">
            <v-btn
              color="success"
              outlined
              rounded
              @click="refreshFilter"
              class="mb-7 pl-5 pr-5 xs-full-width"
            >
              <v-icon left small>mdi-cached</v-icon>Refresh
            </v-btn>
          </div>
        </v-toolbar>
      </template>
      <template v-slot:item.imageCourse="{ item }">
        <v-img :src="item.imageCourse" class="my-2 rounded-card" width="150" aspect-ratio="1.7"></v-img>
      </template>
      <template v-slot:item.imageCourse="{ item }">
        <!-- <v-avatar :color="`grey lighten-2`" elevation="3" size="60" class="my-2"> -->
        <v-img
          :src="item.imageCourse == null ? imageReady : item.imageCourse"
          class="my-2 rounded-card"
          width="150"
          aspect-ratio="1.7"
        >
          <!-- <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-icon v-if="imageReady" class="mx-auto" elevation="3" size="65">mdi-account</v-icon>
              </v-row>
          </template>-->
        </v-img>
        <!-- </v-avatar> -->
      </template>
      <template v-slot:item.title="{ item }">
        <p class="ma-2 md-fixed-width text-left">{{item.title}}</p>
      </template>
      <template v-slot:item.category="{ item }">
        <v-row v-for="category in item.category" :key="category._id">
          <v-chip class="ma-2 xs-fixed-width">{{category.title}}</v-chip>
        </v-row>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-chip
          outlined
          class="mb-0 white--text"
          color="blue-grey"
          @click="$store.state.permission.viewStudent == true ? openDialogGetReport(item) : noPermission()"
        >
          <v-avatar left>
            <v-icon>mdi-call-made</v-icon>
          </v-avatar>
          <p class="mb-0">{{$vuetify.lang.t('$vuetify.courseManagement.courseList.viewReport')}}</p>
        </v-chip>
      </template>
    </v-data-table>
    <v-row justify="center">
      <v-dialog
        v-model="dialogFullReport"
        fullscreen
        persistent
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar flat dark color="primary">
            <v-toolbar-title>
              <v-icon left>mdi-finance</v-icon>รายชื่อผู้เรียนในคอร์ส
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogFullReport = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <div>
              <v-row class="ma-md-5 pa-5">
                <v-col cols="12" class="d-flex">
                  <v-card max-width="200">
                    <v-img
                      class="rounded-card"
                      height="100"
                      :src="imageCourse == null ? imageReady : imageCourse"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center">
                          <v-icon
                            v-if="imageReady"
                            class="my-2 rounded-card"
                            elevation="3"
                            size="80"
                          >mdi-image-area</v-icon>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                  <p class="px-5 display-1 font-weight-regular">{{ title }}</p>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-data-table
                :loading="loading"
                :headers="headerStudents"
                :page.sync="params.page"
                :items-per-page="limit"
                @page-count="pageCount"
                hide-default-footer
                :items="reportStudentList"
                class="pa-5 ma-md-5 font-weight-light"
                elevation="3"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white table-header pa-0">
                    <div class="mr-md-5 xs-full-width">
                      <v-text-field
                        outlined
                        rounded
                        v-model="searchdata"
                        append-icon="search"
                        @click:append="searchInfoStudent"
                        placeholder="Search"
                        clearable
                      ></v-text-field>
                    </div>
                    <div class="ml-5 xs-full-width">
                      <v-btn
                        color="success"
                        outlined
                        rounded
                        @click="refreshStrudent"
                        class="mb-7 pl-5 pr-5 xs-full-width"
                      >
                        <v-icon left small>mdi-cached</v-icon>Refresh
                      </v-btn>
                    </div>
                  </v-toolbar>
                </template>
                <template v-slot:item.image="{ item }">
                  <v-avatar :color="`grey lighten-2`" elevation="3" size="60" class="my-2">
                    <v-img
                      :src="item.image == null ? imageReady : item.image"
                      class="my-2 ml-auto mr-auto rounded-card img-md"
                      aspect-ratio="1"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-icon
                            v-if="imageReady"
                            class="mx-auto"
                            elevation="3"
                            size="65"
                          >mdi-account</v-icon>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
                </template>
                <template v-slot:item.fullName="{ item }">
                  <p class="ma-2 md-fixed-width text-left">{{item.fullName}}</p>
                </template>
                <template v-slot:item.email="{ item }">
                  <p class="ma-2 md-fixed-width text-left">{{item.email}}</p>
                </template>
                <template v-slot:item.userName="{ item }">
                  <p class="ma-2 md-fixed-width text-left">{{item.userName}}</p>
                </template>
                <template v-slot:item.room="{ item }">
                  <v-chip-group column class="md-fixed-max-width">
                    <v-chip small class="ma-2">
                      <p class="mb-0">{{ item.room }}</p>
                    </v-chip>
                  </v-chip-group>
                </template>
                <template v-slot:item.report="{ item }">
                  <v-chip
                    outlined
                    class="mb-0 white--text"
                    color="blue"
                    @click="viewProgressReport(item)"
                  >
                    <v-avatar left>
                      <v-icon>mdi-equalizer</v-icon>
                    </v-avatar>
                    <p class="mb-0">ความคืบหน้า</p>
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-chip
                    outlined
                    class="mb-0 white--text"
                    color="blue-grey"
                    @click="userEdit(item)"
                  >
                    <v-avatar left>
                      <v-icon>mdi-eye</v-icon>
                    </v-avatar>
                    <p class="mb-0">ดูข้อมูล</p>
                  </v-chip>
                </template>
              </v-data-table>

              <v-dialog v-model="dialogFormUser" scrollable persistent max-width="800px">
                <v-card>
                  <v-toolbar flat dark color="primary">
                    <v-toolbar-title>
                      <v-icon left>mdi-account-circle</v-icon>ข้อมูลผู้เรียน
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogFormUser = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class>
                    <v-form ref="form" v-model="valid">
                      <v-container>
                        <v-row>
                          <v-col cols="12" class="mx-auto">
                            <div class="img-padding">
                              <v-avatar :color="`grey lighten-2`" elevation="3" size="200">
                                <v-img
                                  :src="imgPreview == null ? imageReady : imgPreview"
                                  aspect-ratio="1.8"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-icon
                                        v-if="imageReady"
                                        class="mx-auto"
                                        elevation="3"
                                        size="200"
                                      >mdi-account</v-icon>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-avatar>
                            </div>
                            <v-divider class="mt-6"></v-divider>
                          </v-col>
                          <v-col cols="12">
                            <div
                              class="text-center display-1 font-weight-regular"
                            >{{ firstName }} {{ lastName }}</div>
                          </v-col>
                          <v-col cols="12">
                            <div
                              class="text-center headline font-weight-light"
                            ><strong>อีเมล</strong> {{ email }}</div>
                          </v-col>
                          <v-col cols="12">
                            <div
                              class="text-center title font-weight-light"
                            ><strong>Username</strong> {{ username }}</div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      rounded
                      :disabled="!valid"
                      @click="dialogFormUser = false"
                    >ปิด</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogViewReport" scrollable max-width="950px">
                <v-card>
                  <v-toolbar flat dark color="primary">
                    <v-toolbar-title>
                      <v-icon left>mdi-equalizer</v-icon>รายงานความคืบหน้า
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogViewReport = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="8">
                          <div class="img-padding">
                            <v-avatar :color="`grey lighten-2`" elevation="3" size="80">
                              <v-img
                                :src="image == null ? imageReady  : image"
                                class="my-2 ml-auto mr-auto rounded-card img-md"
                                aspect-ratio="1"
                              >
                                <template v-slot:placeholder>
                                  <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-icon
                                      v-if="imageReady"
                                      class="mx-auto"
                                      elevation="3"
                                      size="80"
                                    >mdi-account</v-icon>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  <p
                                    class="ma-2 px-5 md-fixed-width text-left font-weight-bold title"
                                  >{{fullName}}</p>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  <p class="ma-2 px-5 md-fixed-width text-left subtitle">{{email}}</p>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </v-col>
                        <v-col cols="4">
                          <div class="chip-padding">
                            <v-chip class="my-5" color="default">
                              <v-avatar left>
                                <v-icon>mdi-account</v-icon>
                              </v-avatar>
                              <p class="mb-0">ผู้เรียน</p>
                            </v-chip>
                          </div>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                    </v-container>
                    <v-card class="my-5">
                      <v-card-title class="headline pa-2">
                        <v-icon
                          class="pr-3"
                          color="success"
                          size="28"
                        >mdi-checkbox-marked-circle-outline</v-icon>ความสำเร็จ
                      </v-card-title>
                      <v-row class="pa-3">
                        <p class="px-3">เรียนไปแล้ว</p>
                        <v-spacer></v-spacer>
                        <p class="px-3">{{ Math.ceil(knowledge) }}%</p>
                        <v-col cols="12">
                          <v-progress-linear
                            v-model="knowledge"
                            color="success"
                            rounded
                            height="20"
                            reactive
                          ></v-progress-linear>
                        </v-col>
                      </v-row>
                    </v-card>

                    <v-card class="my-5">
                      <v-card-title class="headline pa-2">
                        <v-icon class="pr-3" color="red" size="28">mdi-circle-edit-outline</v-icon>ประวัติการทำข้อสอบ
                      </v-card-title>
                      <v-row class="pa-3">
                        <p class="px-3 my-1">ดาวน์โหลดประวัติการสอบ</p>
                        <v-spacer></v-spacer>
                        <div class="px-3">
                          <v-chip
                            outlined
                            class="mb-0 white--text"
                            color="teal"
                            @click="$store.state.permission.updateStudent == true ? '' : noPermission()"
                          >
                            <v-avatar left>
                              <v-icon>mdi-file-download-outline</v-icon>
                            </v-avatar>
                            <p class="mb-0">Excel</p>
                          </v-chip>
                        </div>
                      </v-row>
                      <v-row class="px-3 align-center">
                        <v-col cols="12">
                          <v-slide-group
                            v-model="statChart"
                            class="pa-4"
                            active-class="success"
                            show-arrows
                          >
                            <v-slide-item v-for="n in 5" :key="n">
                              <v-card outlined class="pa-3 ma-3">
                                <p
                                  class="pa-3"
                                >บทเรียนที่ 1 (ชุดข้อสอบทดสอบความรู้เบื้องต้นเกี่ยวกับระบบสุริยะ)</p>
                                <v-sheet color="cyan" elevation="3" max-width="calc(100% - 5px)">
                                  <v-sparkline
                                    :labels="labels"
                                    :value="value"
                                    color="white"
                                    :min="0"
                                    line-width="2"
                                    padding="16"
                                  ></v-sparkline>
                                  <!-- <bar-chart></bar-chart> -->
                                </v-sheet>

                                <v-card-text class="pt-3 pb-0">
                                  <p>กราฟแสดงคะแนนการสอบในแต่ละครั้ง</p>
                                  <v-divider class="my-2"></v-divider>
                                </v-card-text>
                                <v-row class="pa-3">
                                  <p class="px-3">คะแนนเฉลี่ย</p>
                                  <v-spacer></v-spacer>
                                  <p class="px-3">เต็ม 100</p>
                                  <v-col cols="12">
                                    <v-progress-linear
                                      v-model="knowledge"
                                      color="light-blue"
                                      rounded
                                      height="16"
                                      reactive
                                    >{{ Math.ceil(knowledge) }}</v-progress-linear>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-slide-item>
                          </v-slide-group>
                        </v-col>
                      </v-row>
                    </v-card>

                    <v-card class="my-5">
                      <v-card-title class="headline pa-2">
                        <v-icon class="pr-3" color="indigo" size="28">mdi-clock-fast</v-icon>ประวัติการเข้าเรียน
                      </v-card-title>
                      <v-row class="pa-3">
                        <p class="px-3 my-1">ดาวน์โหลดประวัติการเข้าเรียน</p>
                        <v-spacer></v-spacer>
                        <div class="px-3">
                          <v-chip
                            outlined
                            class="mb-0 white--text"
                            color="teal"
                            @click="$store.state.permission.updateStudent == true ? '' : noPermission()"
                          >
                            <v-avatar left>
                              <v-icon>mdi-file-download-outline</v-icon>
                            </v-avatar>
                            <p class="mb-0">Excel</p>
                          </v-chip>
                        </div>
                      </v-row>
                      <v-row class="px-3">
                        <v-col cols="12">
                          <v-data-table
                            :headers="headersMockup"
                            :items="historyItems"
                            :items-per-page="5"
                            class="elevation-1"
                          ></v-data-table>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-card-text>

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark rounded @click="dialogViewReport = false">ปิด</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-row justify="center">
                <v-dialog v-model="alert" persistent max-width="450">
                  <v-card>
                    <v-card-title class="headline">ขออภัย</v-card-title>
                    <v-card-text>
                      คุณไม่สามารถใช้งานฟังก์ชันนี้ได้ เนื่องจากไม่มีการ
                      <strong>&nbsp;กำหนดสิทธิ์&nbsp;</strong>การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary darken-1" text @click="alert = false">ตกลง</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>

              <div class="text-center">
                <v-pagination v-model="params.page" :length="pageCount"></v-pagination>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <div class="text-center">
      <v-pagination v-model="params.page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>
<script>
import {
  getUserEditByID,
  getUserGroup,
  getUserTeacherList
} from "@/service/account/manageUser";
import { uploadImage } from "@/service/upload/upload";
import {
  getReportCourse,
  getReportStudentInCourse
} from "@/service/course/course";

import VueCharts from "vue-chartjs";
import { Bar } from "vue-chartjs";

export default {
  extends: VueCharts,
  Bar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    alert: false,
    valid: true,
    dialogFormUser: false,
    dialogFullReport: false,
    dialogViewReport: false,

    isEdit: false,
    checkboxPassword: false,
    checkboxPasswordHide: true,
    showPassword: false,
    showConFirmPassword: false,

    permissionStudentAll: false,
    permissionCourseAll: false,

    viewStudent: false, //ข้อมูลผู้ใช้
    insertStudent: false, //เพิ่มรายชื่อ
    updateStudent: false, //แก้ไขรายชื่อผู้ใช้
    activeStudent: false, //ระงับการใช้งาน
    viewCourse: false, //เข้าถึงคอร์ส
    insertCourse: false, //เพิ่มคอร์ส
    updateCourse: false, //แก้ไขคอร์ส
    activeCourse: false, //ระงับคอร์ส
    manageCategory: false, //จัดการ Category
    viewReport: false, //เข้าถึงการรายงาน
    userGroup: false, //จัดการกลุ่มผู้ใช้

    editUser: {},
    loading: true,
    imgPreview: "",
    imgPreview1: null,
    imgPreview2: null,
    description: "",
    note: "",
    checkTeacher: "",
    imageFile: null,
    imageReady: false,
    imageProfileReady: false,
    imageProfileReady1: false,
    imageReady1: false,
    imageReady2: false,
    users: [],
    teachers: [],
    reportCourseList: [],
    reportStudentList: [],
    students: [],
    groupUsers: [],
    selectionGroup: [],
    selection: [],
    editorOption: {},
    statChart: [],
    imageRules: [
      v => !!v || "กรุณาเลือกอัปโหลดรูปภาพ",
      v => v.size < 20000000 || "กรุณาเลือกไฟล์ที่มีขนาดน้อยกว่า 20 MB"
    ],
    nameRules: [v => !!v || "กรุณากรอกข้อมูลให้ครบถ้วน"],
    genderRules: [v => !!v || "กรุณาระบุเพศ"],
    firstNameRules: [v => !!v || "กรุณากรอกชื่อจริง"],
    lastNameRules: [v => !!v || "กรุณากรอกนามสกุล"],
    idCardNumberRules: [v => !!v || "กรุณากรอกเลขบัตรประจำตัวประชาชน"],
    userNameRules: [v => !!v || "กรุณากรอกชื่อผู้ใช้งาน"],
    passwordRules: [
      v => v.length >= 8 || "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป"
    ],

    emailRules: [
      v => !!v || "กรุณากรอกอีเมล",
      v => /.+@.+\..+/.test(v) || "กรุณากรอกให้อยู่ในรูปแบบอีเมล"
    ],

    knowledge: 33,
    searchby: "ทั้งหมด",
    searchType: ["ทั้งหมด", "อนุมัติแล้ว", "รออนุมัติ"],
    sortType: [
      "เวลา สูง-ต่ำ",
      "เวลา ต่ำ-สูง",
      "ยอดนิยม สูง-ต่ำ",
      "ยอดนิยม ต่ำ-สูง"
    ],
    headers: [
      {
        text: "รูปปกคอร์ส",
        align: "start",
        sortable: false,
        value: "imageCourse"
      },
      {
        text: "ชื่อคอร์ส",
        value: "title",
        align: "center",
        sortable: false
      },
      {
        text: "หมวดหมู่/วิชา",
        value: "category",
        align: "center",
        sortable: false
      },
      {
        text: "รายงาน",
        value: "actions",
        align: "center",
        sortable: false
      }
    ],
    headerStudents: [
      {
        text: "รูปโปรไฟล์",
        align: "center",
        sortable: false,
        value: "image"
      },
      {
        text: "ชื่อ-นามสกุล",
        value: "fullName",
        align: "center",
        sortable: false
      },
      { text: "อีเมล", value: "email", align: "center", sortable: false },
      {
        text: "ชื่อผู้ใช้งาน",
        value: "userName",
        align: "center",
        sortable: false
      },
      { text: "ห้องเรียน", value: "room", align: "center", sortable: false },
      { text: "รายงาน", value: "report", align: "center", sortable: false },
      {
        text: "ข้อมูลผู้เรียน",
        value: "actions",
        align: "center",
        sortable: false
      }
    ],
    headersMockup: [
      {
        text: "วันที่",
        align: "center",
        sortable: false,
        value: "date"
      },
      {
        text: "เวลาที่ใช้งาน",
        align: "center",
        value: "timeLearn",
        sortable: false
      },
      { text: "กิจกรรม", align: "center", value: "activity", sortable: false }
    ],
    historyItems: [
      {
        date: "4 เมษายน 2563",
        timeLearn: "03:00:00 ชม.",
        activity: "ดาราศาสตร์"
      },
      {
        date: "10 เมษายน 2563",
        timeLearn: "03:00:00",
        activity: "วิทยาศาสตร์ ชม."
      }
    ],

    editUserId: "",
    courseId: "",
    fullName: "",
    room: "",
    firstName: "",
    lastName: "",
    selectedGender: "",
    email: "",
    username: "",
    password: "",
    conFirmPassword: "",
    image: null,
    imageCourse: null,
    searchdata: "",
    sortData: "",
    searchCourse: null,
    pageCount: 1,
    limit: 10,
    searchStudent: null,
    category: [],
    skill: [],
    selectedSkill: [],
    selectedCategory: [],
    active: "null",
    params: {},
    deleteItemID: [],
    genders: [
      {
        text: "ชาย",
        value: "male"
      },
      {
        text: "หญิง",
        value: "female"
      }
    ]
  }),
  computed: {
    conFirmPasswordRules() {
      const rules = [];
      if (this.password) {
        const rule = v =>
          (!!v && v) === this.password || "กรุณากรอกรหัสผ่านให้ตรงกัน";
        rules.push(rule);
      }
      return rules;
    }
  },

  mounted() {
    this.initialize();
    this.renderChart(
      {
        labels: [
          "ครั้งที่ 1",
          "ครั้งที่ 2",
          "ครั้งที่ 3",
          "ครั้งที่ 4",
          "ครั้งที่ 5"
        ],
        datasets: [
          {
            label: "คะแนนที่ได้",
            backgroundColor: "#f87979",
            data: [40, 39, 10, 40, 39]
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  },

  methods: {
    initialize() {
      this.params = {
        search: null,
        sort: null,
        sortby: null,
        page: 1,
        limit: 1000,
        active: "null"
      };

      if (!this.$store.state.permission.viewStudent) {
        this.noPermission();
      } else {
        this.getReportCourseList();
      }

      this.loading = false;
      this.searchdata = "";
      this.active = "null";
    },

    changeState() {
      this.insertStudent = false; //เพิ่มรายชื่อ
      this.updateStudent = false; //แก้ไขรายชื่อผู้ใช้
      this.activeStudent = false; //ระงับการใช้งาน
    },
    changeStateUpdate() {
      if (this.insertStudent == false && this.updateStudent == false) {
        this.activeStudent = false; //ระงับการใช้งาน
      }
    },

    changeStateCourse() {
      this.insertCourse = false; //เพิ่มคอร์ส
      this.updateCourse = false; //แก้ไขคอร์ส
      this.activeCourse = false; //ระงับคอร์ส
    },
    changeStateUpdateCourse() {
      if (this.insertCourse == false && this.updateCourse == false) {
        this.activeCourse = false; //ระงับคอร์ส
      }
    },

    refreshFilter() {
      this.initialize();
    },
    refreshStrudent() {
      this.getStudentCourseList();
    },

    async preview() {
      if (this.imageFile != null) {
        this.imgURL = await this.uploadImg(this.imageFile);
        this.imgPreview = this.imgURL;
        this.imageReady = true;
        console.log("UPLOADED IMAGE:", this.imgPreview);
      } else {
        this.imageReady = false;
      }
    },

    async uploadImg(image) {
      let status = await uploadImage("user", image);
      return status;
    },

    searchInfoCourse() {
      this.params.search = this.searchdata;
      this.getReportCourseList();
    },

    searchInfoStudent() {
      this.params.search = this.searchdata;
      this.getStudentCourseList();
    },

    async openDialogGetReport(item) {
      this.dialogFullReport = true;
      this.imageCourse = item.imageCourse;
      this.title = item.title;
      this.courseId = item.id;
      this.getStudentCourseList();
    },
    async getStudentCourseList() {
      this.loading = true;
      let result = await getReportStudentInCourse({
        idcourse: this.courseId,
        search: this.params.search
      });
      console.log(result.data);
      this.reportStudentList = [];
      result.data.forEach(student => {
        this.reportStudentList.push({
          id: student._id,
          image: student.image,
          fullName: student.firstName + " " + student.lastName,
          email: student.email,
          userName: student.username,
          room: student.room.title
        });
      });
      this.imageReady = true;
      this.loading = false;
    },

    async getReportCourseList() {
      this.loading = true;

      // localStorage.removeItem("editCourseID");
      let result = await getReportCourse(this.params);
      console.log("report list course", result);
      this.reportCourseList = [];
      result.forEach(course => {
        this.reportCourseList.push({
          id: course._id,
          imageCourse: course.image,
          title: course.title,
          category: course.categories
        });
      });
      this.imageReady = true;
      this.loading = false;
    },

    async getTeacherList() {
      this.loading = true;

      let result = await getUserTeacherList(this.params);
      console.log("teacher list ", result);
      this.teachers = [];
      result.forEach(teacher => {
        this.teachers.push({
          id: teacher._id,
          image: teacher.image,
          fullName: teacher.firstName + " " + teacher.lastName,
          email: teacher.email,
          username: teacher.username,
          course: {
            buy: teacher.countBuyCourse,
            create: teacher.countCourseCreate
          },
          active: teacher.active,
          group: teacher.user_groups,
          isTeacher: teacher.isTeacher,
          verifyTeacher: teacher.verifyTeacher
        });
      });
      this.imageReady = true;
      this.loading = false;
    },

    async getUserGroup(item) {
      this.dialogGroupUser = true;
      this.editUserId = item.id;
      let index = this.users.indexOf(item);
      let result = await getUserGroup(this.params);
      console.log("result", result);

      this.groupUsers = result;

      console.log("groupUsers", this.groupUsers);
      if (this.editUserId) {
        this.selection = this.users[index].group.map(group => group._id);
      }
      console.log("set data", this.selection);
    },

    async getUserEdit(item) {
      console.log(this.isEdit);
      let result = await getUserEditByID({ idstudent: item.id });
      console.log("result ", result);
      this.editUserId = item.id;
      this.editUserCompanies = result.companies[0];
      this.imgPreview = result.image;
      this.imageReady = true;
      this.selectedGender = this.genders.filter(
        gender => gender.value == result.gender
      )[0].value;
      this.firstName = result.firstName;
      this.lastName = result.lastName;
      this.email = result.email;
      this.username = result.username;

      //permission//
      this.viewStudent = result.permission.viewStudent; //ข้อมูลผู้ใช้
      this.insertStudent = result.permission.insertStudent; //เพิ่มรายชื่อ
      this.updateStudent = result.permission.updateStudent; //แก้ไขรายชื่อผู้ใช้
      this.activeStudent = result.permission.activeStudent; //ระงับการใช้งาน

      this.viewCourse = result.permission.viewCourse; //เข้าถึงคอร์ส
      this.insertCourse = result.permission.insertCourse; //เพิ่มคอร์ส
      this.updateCourse = result.permission.updateCourse; //แก้ไขคอร์ส
      this.activeCourse = result.permission.activeCourse; //ระงับคอร์ส

      this.manageCategory = result.permission.viewCategory; //จัดการ Category

      this.viewReport = result.permission.viewReport; //เข้าถึงการรายงาน

      this.userGroup = result.permission.viewUserGroup; //จัดการกลุ่มผู้ใช้
    },

    async userEdit(item) {
      this.dialogFormUser = true;
      this.imageReady = true;

      if (item) {
        this.isEdit = true;
        this.getUserEdit(item);
        this.checkboxPassword = false;
        this.checkboxPasswordHide = true;
      } else {
        this.isEdit = false;
        this.checkboxPassword = true;
        this.checkboxPasswordHide = false;
        this.$refs.form.resetValidation();

        this.firstName = "";
        this.lastName = "";
        this.gender = "";
        this.email = "";
        this.username = "";
        this.password = "";
        this.conFirmPassword = "";
        this.image = "";
        this.imgPreview = "";
        (this.imageFile = null), (this.viewStudent = false); //ข้อมูลผู้ใช้
        this.insertStudent = false; //เพิ่มรายชื่อ
        this.updateStudent = false; //แก้ไขรายชื่อผู้ใช้
        this.activeStudent = false; //ระงับการใช้งาน

        this.viewCourse = false; //เข้าถึงคอร์ส
        this.insertCourse = false; //เพิ่มคอร์ส
        this.updateCourse = false; //แก้ไขคอร์ส
        this.activeCourse = false; //ระงับคอร์ส

        this.manageCategory = false; //จัดการ Category

        this.viewReport = false; //เข้าถึงการรายงาน

        this.userGroup = false; //จัดการกลุ่มผู้ใช้
      }
    },

    async viewProgressReport(item) {
      this.dialogViewReport = true;
      this.image = item.image;
      this.fullName = item.fullName;
      this.email = item.email;
    },

    async userConfirm(item) {
      this.dialogUserConfirm = true;
      this.imageReady1 = true;
      this.imageReady2 = true;
      this.imageProfileReady = true;
      this.editUserId = item.id;
      let index = this.teachers.indexOf(item);
      console.log("teacher id ", this.editUserId);
      console.log("teacher index ", index);
      console.log("result teacher", this.teachers);
      console.log(this.teachers[index].verifyTeacher);
      this.getUserEdit(item);
      if (this.editUserId) {
        this.teachers[index].verifyTeacher.map(
          (this.image = this.teachers[index].image),
          (this.email = this.teachers[index].email),
          (this.fullName = this.teachers[index].fullName),
          (this.imgPreview1 = this.teachers[index].verifyTeacher.image[0]),
          (this.imgPreview2 = this.teachers[index].verifyTeacher.image[1]),
          (this.description = this.teachers[index].verifyTeacher.description)
        );
      }
    },

    noPermission() {
      console.log("no permission");
      this.alert = true;
    }
  }
};
</script>
<style scope>
.theme--light.v-input--is-disabled,
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: black;
}
.rounded-card {
  border-radius: 8px;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
}
.v-input__append-inner {
  margin-top: 9px !important;
}
.md-fixed-max-width {
  max-width: 250px;
}
.max-width {
  width: 100%;
}
.img-md {
  width: 80px;
}
.editor {
  height: 200px;
  margin-bottom: 70px;
}
.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}
.chip-padding {
  text-align: right;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

@media only screen and (max-width: 1440px) {
  .md-fixed-width {
    width: 100px;
  }
  .xs-fixed-width {
    width: 80px;
  }
}
@media only screen and (max-width: 768px) {
  .img-md {
    width: 60px;
    height: 60px;
  }
  .md-fixed-width {
    width: 100px;
  }
  .xs-fixed-width {
    width: 100px;
  }
  .xs-m {
    margin-top: 28px !important;
  }
  .xs-full-max-width {
    max-width: 100%;
  }
  .table-header {
    height: auto !important;
  }
  .table-header .v-toolbar__content {
    height: auto !important;
    flex-flow: column;
    padding: 0 !important;
  }
  .xs-full-width {
    width: 50%;
  }
}
</style>
